const state = {
  currentMode: 'normal', // Global default mode
  offerModes: {} // Per-offer mode storage: { offerId: mode }
}

const mutations = {
  setSendCvMode (state, { offerId, mode }) {
    // Update the mode for a specific offer
    state.offerModes = {
      ...state.offerModes,
      [offerId]: mode
    }

    // Also update the global current mode
    state.currentMode = mode
  },

  clearOfferMode (state, offerId) {
    // Remove mode for a specific offer
    const newOfferModes = { ...state.offerModes }
    delete newOfferModes[offerId]
    state.offerModes = newOfferModes
  },

  setGlobalMode (state, mode) {
    // Set global default mode
    state.currentMode = mode
  },

  resetAllModes (state) {
    // Reset all modes to normal
    state.currentMode = 'normal'
    state.offerModes = {}
  }
}

const actions = {
  setSendCvMode ({ commit }, payload) {
    commit('setSendCvMode', payload)
  },

  clearOfferMode ({ commit }, offerId) {
    commit('clearOfferMode', offerId)
  },

  setGlobalMode ({ commit }, mode) {
    commit('setGlobalMode', mode)
  },

  resetAllModes ({ commit }) {
    commit('resetAllModes')
  }
}

const getters = {
  getCurrentMode: (state) => state.currentMode,

  getOfferMode: (state) => (offerId) => {
    return state.offerModes[offerId] || state.currentMode
  },

  getAllOfferModes: (state) => state.offerModes,

  isLiteMode: (state) => (offerId) => {
    const mode = state.offerModes[offerId] || state.currentMode
    return mode === 'lite'
  },

  isSuperLiteMode: (state) => (offerId) => {
    const mode = state.offerModes[offerId] || state.currentMode
    return mode === 'super_lite'
  },

  isNormalMode: (state) => (offerId) => {
    const mode = state.offerModes[offerId] || state.currentMode
    return mode === 'normal'
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
